export const passwordResetFields = {
    email: {
        name: "email",
        label: "Email Address",
        required: true,
    },
}

export const confirmPasswordResetFields = {
    email: {
        name: "email",
        label: "Email Address",
        required: true,
    },
    confirmationCode: {
        name: "code",
        label: "Confirmation Code",
        required: true,
    },
    password: {
        name: "password",
        label: "Password",
        required: true,
    },
    confirmPassword: {
        name: "confirm_password",
        label: "Confirm Password",
        required: true,
    },
}